// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PRUY","inner":"Footer_inner__20IPo"};